// extracted by mini-css-extract-plugin
export default {"OverlayLoader":"TableLoader_OverlayLoader__jHirP"};